import React, { FC } from 'react';
import { Modal, Paper } from '@mui/material';

import { SuccessIcon } from '@assets/icons';

import { PublishSuccessModalType } from './types';
import { translate } from '@utils/locale';

const PublishSuccessModal: FC<PublishSuccessModalType> = ({
  dealName,
  isModalOpen
}) => {
  return (
    <Modal open={isModalOpen}>
      <div className="flex justify-center items-center h-full bg-black/60">
        <Paper
          style={{
            paddingTop: 16,
            paddingBottom: 16,
            paddingLeft: 24,
            paddingRight: 24,
            width: 444
          }}>
          <div className="flex flex-col">
            <div className="self-center">
              <SuccessIcon />
            </div>
            <div className="self-center mx-8 mt-2 text-xl font-medium leading-8 text-center">
              <span className="inline-block max-w-[300px] truncate align-middle">
                {dealName}
              </span>
              <span>{translate('modals.publishSuccess')}</span>
            </div>
          </div>
        </Paper>
      </div>
    </Modal>
  );
};

export default PublishSuccessModal;
